<div class="az-date-picker">
  @if (label) {
    <span class="az-date-picker__label">{{ label }}</span>
  }
  <div class="az-date-picker__wrapper" [class.az-date-picker__wrapper--disabled]="disabled">
    <input
      type="date"
      [id]="id"
      class="az-date-picker__input"
      [value]="value"
      [disabled]="disabled"
      (input)="onDateChange($any($event.target).value)"
    />
    <div class="az-date-picker__icon-container">
      <span class="material-symbols-outlined az-date-picker__icon">calendar_month</span>
    </div>
  </div>
</div>
